import {
  IPropertyDetailsResponse,
  ValidationDocument
} from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export interface IPropertyDetailValidation {
  id: number;
  name: string;
  url: string;
  dateExpedition: string | null;
  status: {
    pending: boolean;
    approved: boolean;
    rejected: boolean;
  };
  status_comment: string | null;
  validated_at: string | null;
  has_alert: boolean;
  message_alert: string | null;
}

export const prepareDetailPropertyValidations = (
  data: IPropertyDetailsResponse
): IPropertyDetailValidation[] => {
  if (
    Object(data).hasOwnProperty("project") &&
    Object(data.project).hasOwnProperty("validation_documents") &&
    Object(data).hasOwnProperty("validation_document_alerts")
  ) {
    const prepareMessageAlert = (item: ValidationDocument) => {
      if (item.status === "pending") {
        return `El documento está pendiente `;
      } else if (item.status === "approved") {
        return `Documento aprobado `;
      } else if (item.status === "rejected") {
        return `Documento rechazado `;
      }
      return null;
    };

    return data.project.validation_documents.map(item => {
      const validation = data?.validation_document_alerts?.find(
        x => x.document_type_id === item.document_type_id
      );
      return {
        id: item.id,
        name: item.document_type_name || "",
        url: item.filename,
        dateExpedition: item.expedition_date,
        status: {
          pending: item.status === "pending",
          approved: item.status === "approved",
          rejected: item.status === "rejected"
        },
        status_comment: item.status_comment,
        has_alert: validation ? true : false,
        message_alert: validation ? prepareMessageAlert(item) : null,
        validated_at: item.validated_at
      };
    });
  } else {
    return [];
  }
};
